﻿import React from 'react';
import { motion} from 'framer-motion';


const ConditionalFadeIn = ({active, children}) => (
    typeof active !== 'undefined' && active === true
        ? <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            {children}
        </motion.div>
        : <div>{children}</div>
);

export default ConditionalFadeIn; 
